import * as React        from "react";
import {cs}              from "@Common/react/chain-services";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faX}             from "@fortawesome/free-solid-svg-icons";
import {UseState}        from "@Common/react/use-state";
import {consumeContext}  from "@Common/react/context";
import './internalInfo.scss';

export const InternalInfo = ({
    item, isBuild3Page, ccVersion
}:{
    item : any,
    isBuild3Page: boolean,
    ccVersion: string,
}) => cs(
    consumeContext("systemConstants"),
    ["state", (_,next) => UseState({
        initValue: {
            content: 'internal-info-xd4',
        },
        next
    })],
    ["CRMDynamicURL", ({systemConstants}, next) => {
        const url = "formid={43C68BFF-49F6-4668-B325-CF67608F1B89}&xpd_ordernumbers=" +
        (item?.itemId ? item?.itemId : '') +
        "&xpd_agentid=" +
        ((item.idAgent != '' && item.idAgent != "Branch Order") ? item.idAgent : '') +
        "&xpd_branchid=" +
        (item.idBranch != '' ? item.idBranch : '') +
        "&xpd_companyid=" + item.idCompany
        const encodedQueryString = encodeURIComponent(url);
        return next(
            systemConstants?.value?.CRM_URL +
            '?etn=incident&cmdbar=true&navbar=on&pagetype=entityrecord&extraqs=' +
            encodedQueryString
        );
    }],
    ({state, CRMDynamicURL}) => (
        <>
            <div className={state.value.content}>
                <div
                    id="close"
                    className="close-icon"
                    onClick={(e) => {
                        state.onChange({...state.value, content: state.value.content+" internal-info-close-b3"})
                    }}
                    xd-qa-type="link"
                    xd-qa-name="close"
                >
                    <FontAwesomeIcon icon={faX} className="img-close" />
                </div>
                <h2 xd-qa-type="label" xd-qa-name="Internal Info">Internal Info</h2>
                <div>
                    <strong>Order ID: </strong>
                    <a href={`${location.protocol}//${location.host}/next/xadmin/orders/index.php?procform=1&id_order=${item?.itemId}`} target="_blank" xd-qa-type="link" xd-qa-name={item?.itemId}>{item?.itemId}</a>
                </div>
                {ccVersion && <div>
                    <strong>CustCanv Version: </strong>{ccVersion}
                </div>
                }
                <div xd-qa-type="label" xd-qa-name="Company">
                    <strong>Company: </strong>{item.companyName+"("+item.idCompany+")"}
                </div>
                <div xd-qa-type="label" xd-qa-name="Branch">
                    <strong>Branch: </strong>{item.branchName+"("+item.idBranch+")"}
                </div>
                <div xd-qa-type="label" xd-qa-name="Agent">
                    <strong>Agent: </strong>{item.agentName+"("+item.idAgent+")"}
                </div>
                <div>
                    <a href={CRMDynamicURL} target="_blank" xd-qa-type="link" xd-qa-name="CRM-Link">Create a Case</a>
                </div>
                {isBuild3Page && <div>
                    <a href={`${location.protocol}//${location.host}/next/build2.php?id_order=${item?.itemId}&build3_template_front=${item.sku?.front}&build3_template_back=${item.sku?.back}`} xd-qa-type="link" xd-qa-name="Open In Build 2">Open In Build 2</a>
                    <br/>
                    <a href={`${location.protocol}//${location.host}/next/win_compare.php?id_order=${item?.itemId}`} xd-qa-type="link" xd-qa-name="Generate Windows Comparison">Generate Windows Comparison</a>
                </div>
                }
            </div>
            <div
                className="toggle-internal-info-b3"
                onClick={(e) => {
                    state.onChange({...state.value, content: "internal-info-xd4"})
                }}
                xd-qa-type="link"
                xd-qa-name="Internal Info"
            >
                <span>Internal Info</span>
            </div>
        </>
    )
);